import React from "react";
import { Dumbbell, Repeat2 } from "lucide-react";

const fmtSet = (s) => {
  const reps = s.reps != null && s.reps !== "" ? s.reps : "–";
  const wt = (s.weight_text || "").trim() || (s.weight != null && s.weight !== "" ? s.weight : "");
  const unit = s.weight_unit || "";
  if (!wt) return `${reps}`;
  if (unit === "bw") return `${reps}×BW`;
  if (unit === "band") return `${reps}×${wt} band`;
  return `${reps}×${wt}${unit ? ` ${unit}` : ""}`;
};

/** Compact "what they lifted" readout for a logged strength workout. */
export const StrengthSetsSummary = ({ entries, testid = "strength-sets-summary", compact = false }) => {
  const rows = (entries || []).filter((e) => (e.sets || []).length > 0 || e.swapped_from_name);
  if (!rows.length) return null;
  return (
    <div className={`${compact ? "mt-1" : "mt-2"} space-y-0.5`} data-testid={testid}>
      {rows.map((e, i) => (
        <div key={`${e.exercise_name}-${i}`} className="text-[11px] leading-snug text-[var(--tir-ink)] flex items-start gap-1.5" data-testid={`${testid}-row-${i}`}>
          <Dumbbell size={10} className="mt-[3px] shrink-0 text-[var(--tir-muted)]" />
          <span className="min-w-0">
            <span className="font-semibold">{e.exercise_name || "Exercise"}</span>
            {e.swapped_from_name && (
              <span className="ml-1 text-[9px] tracking-[0.16em] uppercase text-[var(--tir-burgundy)] inline-flex items-center gap-0.5" title={`Swapped from ${e.swapped_from_name}`}>
                <Repeat2 size={9} /> swapped from {e.swapped_from_name}
              </span>
            )}
            {(e.sets || []).length > 0 && (
              <span className="ml-1.5 font-mono-tir text-[var(--tir-muted)]">
                {e.sets.map(fmtSet).join(" · ")}
              </span>
            )}
          </span>
        </div>
      ))}
    </div>
  );
};
